import { promisify } from "./utils/Promisify";

function showOverlayFnDescriptor(overlayName: string) {
  return {
    type: "SHOW_OVERLAY_BY_NAME" as const,
    payload: { overlayName },
  };
}

export type TShowOverlayArgs = Parameters<typeof showOverlayFnDescriptor>;
export type TShowOverlayDescription = ReturnType<typeof showOverlayFnDescriptor>;
export type TShowOverlayActionType = TShowOverlayDescription["type"];

function closeOverlayFnDescriptor(overlayName: string) {
  return {
    type: "CLOSE_OVERLAY" as const,
    payload: { overlayName },
  };
}

export type TCloseOverlayArgs = Parameters<typeof closeOverlayFnDescriptor>;
export type TCloseOverlayDescription = ReturnType<typeof closeOverlayFnDescriptor>;
export type TCloseOverlayActionType = TCloseOverlayDescription["type"];

async function closeOverlay(...args: TCloseOverlayArgs) {
  return promisify(closeOverlayFnDescriptor)(...args);
}

export { closeOverlay };
